export default __webpack_public_path__ + "static/stakes@2x-89c2cdf72c0b03b941426bcfceb663dd.png";